/**
 * Central config for the Idle Session Manager.
 * All values are in milliseconds. Change here to adjust org-wide policy.
 */
export const SESSION_IDLE_CONFIG = {
  /** Total idle time before auto-logout (30 min). */
  logoutAfterMs: 30 * 60 * 1000,
  /** When to show the warning modal (25 min → 5 min countdown). */
  warnAfterMs: 25 * 60 * 1000,
  /** Throttle activity resets to at most once per this interval. */
  activityThrottleMs: 2000,
  /** BroadcastChannel name for cross-tab sync. */
  channelName: "vazoul-idle-session",
  /** localStorage key used as a fallback sync signal. */
  storageKey: "vazoul-idle-last-activity",
  /** Redirect target with expiry flag. */
  expiredRedirect: "/auth?session_expired=1",
} as const;

export const SESSION_IDLE_EVENTS: (keyof WindowEventMap)[] = [
  "mousedown",
  "mousemove",
  "keydown",
  "wheel",
  "touchstart",
  "scroll",
];
